
import { Drawer } from "melco-ui";
import { useGenericDrawer } from "../../../hooks/drawer/useGenericDrawer";
import { AddFolderForm } from "../form/AddFolderForm";

type AddFolderDrawerProps = {
  isDrawerOpen: boolean;
  setDrawerOpen: (isDrawerOpen: boolean) => void;
  callBackFn: (name: string) => void
};

export const AddFolderDrawer: React.FC<AddFolderDrawerProps> = ({
  isDrawerOpen,
  setDrawerOpen,
  // licenseSerialNumberToAddFolder,
  //licenseProductCode
  callBackFn
}) => {

  const referenceDrawer = useGenericDrawer()

  return (

    <Drawer
      title={"Add New Folder"}
      placement="right"
      width={750}
      closable={true}
      onClose={() => setDrawerOpen(false)}
      open={isDrawerOpen}
      bodyStyle={{ padding: '32px' }}
    >
      {isDrawerOpen && <AddFolderForm callBackFn={callBackFn} referenceDrawer={referenceDrawer} onCloseDrawer={setDrawerOpen} />}
    </Drawer>
  );
};
